import React, { useState, useEffect } from 'react';
import api from '../../services/Api';
import { Button, Modal } from 'react-bootstrap';
import { TextField, MenuItem } from '@material-ui/core';
import { Category } from '../../types/Dre';

export type ModalType = {
    modalAdd: boolean
    setModalAdd: React.Dispatch<React.SetStateAction<boolean>>

    nameAdd: string
    setNameAdd: React.Dispatch<React.SetStateAction<string>>

    type: string
    setType: React.Dispatch<React.SetStateAction<string>>

    listCategoriesAdd: Category[]
    setListCategoriesAdd:  React.Dispatch<React.SetStateAction<Category[]>>

    getCategoriesRevenue: () => void
    getCategoriesExpense: () => void
}

export default function ModalAdd(props: ModalType) {

    async function add() {
        var response = await api.post(`/dre`, {
            name: props.nameAdd,
            type: props.type,
        });

        props.setNameAdd('')
        props.getCategoriesRevenue()
        props.getCategoriesExpense()
        props.setModalAdd(false)
    }

    return (
        <Modal
            show={props.modalAdd}
            onHide={() => props.setModalAdd(false)}
            aria-labelledby="contained-modal-warning"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center">
                    Adicionar categoria
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TextField
                    size="small"
                    label="Nome da categoria*"
                    margin="normal"
                    onChange={(e) => props.setNameAdd(e.target.value)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button className="text-dark" variant="success" type="submit" onClick={add}>
                    <i className="fas fa-check text-dark"></i>
                    Adicionar
                </Button>
                <Button variant="secondary" type="button" onClick={() => props.setModalAdd(false)}>
                    <i className="fas fa-times"></i>
                    Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}